export default {
  namespaced: true,
  helpdesk: {
    title: "Helpdesk",
    agent:{
      title: "Agente",
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email",
      is_active: "Is Active",
    },
    group:{
      title: "Grupo",
      name: "Nombre",
      description: "Descripción",
      is_active: "Activo",
    },
    ticket:{
      title: "Ticket|Tickets",
      create_ticket: "Crear ticket",
      created_at: "Fecha De Creación",
      name: "Nombre",
      from: "De",
      subject: "Subject",
      message: "Mensaje",
      description: "Descripción",
      priority: "Prioridad",
      status: "Estado",
      attachments: "Adjuntar un archivo",
      update: "Actualizar",
      cc: "CC",
      for: "Para",
      owner: 'Propietario',
      type: 'Tipo',
      ticket_type: 'Ticket tipo',
    }
  }
};
